import { Navigate, Route, Routes } from 'react-router-dom';
import HomePage from './components/HomePage';
import DocLayout from './components/DocLayout';
import DocView from './components/DocView';
import RequireAuth from './components/RequireAuth';
import RequireStaff from './components/RequireStaff';
import AdminPage from './components/AdminPage';
import ActivityTracker from './components/ActivityTracker';
import DeckView from './components/DeckView';

export default function App() {
  return (
    <>
      <ActivityTracker />
      <Routes>
      <Route path="/" element={<HomePage />} />
      <Route
        element={
          <RequireAuth>
            <DocLayout />
          </RequireAuth>
        }
      >
        <Route path="/d/:group/:slug" element={<DocView />} />
        <Route path="/d/:group/:slug/:tab" element={<DocView />} />
      </Route>
      <Route
        path="/decks/:slug"
        element={
          <RequireAuth>
            <DeckView />
          </RequireAuth>
        }
      />
      <Route
        path="/admin"
        element={
          <RequireAuth>
            <RequireStaff>
              <AdminPage />
            </RequireStaff>
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
